import {createCompiler} from 'core/core';
import {isAEMAuthorMode} from 'core/helpers/aem';
import {initComponent} from 'core/helpers/component';

export const compile = createCompiler('core', ($) => {
  // Handles focus related behaviour
  initComponent(require('core/focus-states'));

  // Cinematic behaviour handling
  initComponent(require('core/hpe-reduced-motion-control'));

  // Init Privacy Banner
  initComponent(require('core/hpe-privacy-banner'));

  // i18n support
  initComponent(require('core/auto-i18n-collect'), null, $);

  // Anchor Custom Behaviour
  initComponent(require('core/anchor-scroller'));
  initComponent.$if($('[hpe-track-anchor]')) && initComponent(require('core/hpe-track-anchor-mixin'), $('[hpe-track-anchor]'));


  /* CORE */
  initComponent(require('core/video-initializer'), null, $);
  initComponent.$if($('.js-text-collapsible')) && initComponent(require('core/text-collapsible'), $('.js-text-collapsible'));  // TODO: rewrite to mixin and init via async

  initComponent(require('design-3.0/hpe-pathfactory.init'));

  /* Web Components Core helpers */
  initComponent(require('core/trigger-analytics'));

  /* PROCESSORS */
  initComponent(require('styleguide/arrow-link'));
  initComponent(require('design-3.0/click-to-call'));

  /* Test components */
  initComponent(require('styleguide/font-test'));

  /* Core common */
  initComponent(require('core/image-accent'));
  initComponent(require('core/base-modal'));
  initComponent(require('core/generic-modal'));
  initComponent(require('core/hpe-compile-mixin'));
  initComponent(require('core/line-clamp'));
  initComponent(require('core/hpe-query-params-mixin'));
  initComponent(require('core/video-overlay-mixin'));
  initComponent(require('core/cta-group-mixin'));
  initComponent(require('core/asset-viewer-modal-initializer'));

  /* Async common */
 initComponent.$if($('media-wrapper')) && require.ensure('core/media-wrapper',
            function(require) { initComponent.$if($('media-wrapper')) && initComponent(require('core/media-wrapper'), $('media-wrapper'));;},
            function(error) { require('core/log').error("Can't load core/media-wrapper", error); },
            'core/media-wrapper'
            );
 initComponent.$if($('esl-carousel, [has-esl-carousel]')) && require.ensure('core/esl-carousel',
            function(require) { initComponent.$if($('esl-carousel, [has-esl-carousel]')) && initComponent(require('core/esl-carousel'), $('esl-carousel, [has-esl-carousel]'));;},
            function(error) { require('core/log').error("Can't load core/esl-carousel", error); },
            'core/esl-carousel'
            );
 initComponent.$if($('background-wrapper')) && require.ensure('core/background-wrapper',
            function(require) { initComponent.$if($('background-wrapper')) && initComponent(require('core/background-wrapper'), $('background-wrapper'));;},
            function(error) { require('core/log').error("Can't load core/background-wrapper", error); },
            'core/background-wrapper'
            );
 initComponent.$if($('hpe-asset-viewer')) && require.ensure('core/asset-viewer-initializer',
            function(require) { initComponent.$if($('hpe-asset-viewer')) && initComponent(require('core/asset-viewer-initializer'), $('hpe-asset-viewer'));;},
            function(error) { require('core/log').error("Can't load core/asset-viewer-initializer", error); },
            'core/asset-viewer-initializer'
            );
 initComponent.$if($('[routing-link]')) && require.ensure('core/routing-link-mixin',
            function(require) { initComponent.$if($('[routing-link]')) && initComponent(require('core/routing-link-mixin'), $('[routing-link]'));;},
            function(error) { require('core/log').error("Can't load core/routing-link-mixin", error); },
            'core/routing-link-mixin'
            );

  /* No usage at that point
  *initComponent.$if($('[css-calc-mixin]')) && require.ensure('core/css-calc-mixin',
            function(require) { initComponent.$if($('[css-calc-mixin]')) && initComponent(require('core/css-calc-mixin'), $('[css-calc-mixin]'));;},
            function(error) { require('core/log').error("Can't load core/css-calc-mixin", error); },
            'core/css-calc-mixin'
            );
  *initComponent.$if($('[css-lazy-bg]')) && require.ensure('core/css-lazy-bg-mixin',
            function(require) { initComponent.$if($('[css-lazy-bg]')) && initComponent(require('core/css-lazy-bg-mixin'), $('[css-lazy-bg]'));;},
            function(error) { require('core/log').error("Can't load core/css-lazy-bg-mixin", error); },
            'core/css-lazy-bg-mixin'
            );
  */

 initComponent.$if($('[esl-match-height]')) && require.ensure('core/match-height-mixin',
            function(require) { initComponent.$if($('[esl-match-height]')) && initComponent(require('core/match-height-mixin'), $('[esl-match-height]'));;},
            function(error) { require('core/log').error("Can't load core/match-height-mixin", error); },
            'core/match-height-mixin'
            );
 initComponent.$if($('[print-trigger]')) && require.ensure('core/print-trigger-mixin',
            function(require) { initComponent.$if($('[print-trigger]')) && initComponent(require('core/print-trigger-mixin'), $('[print-trigger]'));;},
            function(error) { require('core/log').error("Can't load core/print-trigger-mixin", error); },
            'core/print-trigger-mixin'
            );

 initComponent.$if($('[art-text-parallax]')) && require.ensure('styleguide/art-text.parallax',
            function(require) { initComponent.$if($('[art-text-parallax]')) && initComponent(require('styleguide/art-text.parallax'), $('[art-text-parallax]'));;},
            function(error) { require('core/log').error("Can't load styleguide/art-text.parallax", error); },
            'styleguide/art-text.parallax'
            );

  /* AEM Utils */
  (async function () {
    if (!isAEMAuthorMode()) return;
    await import(/* webpackChunkName: "core/aem-utils" */ 'core/aem-utils');
  })();
});
